import { ChangeDetectionStrategy, Component } from '@angular/core';
import { IconComponent } from '@kin/spark-ui';

/**
 * The one loading indicator on /signup: a spinning loader-circle followed by the projected label. Used by the
 * address lookup, the Form 50-162 pad and the CTAs, so every wait on the page looks the same. Hosts may
 * override `color` (the CTA uses its button text color).
 */
@Component({
  selector: 'app-signup-loader',
  imports: [IconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { role: 'status' },
  template: `<ngk-icon icon="loader-circle" size="20px" /><ng-content />`,
  styles: `
    :host {
      display: flex; align-items: center; justify-content: center; gap: 10px;
      font-size: 16px; font-weight: 600; color: var(--kin-text-secondary);
    }
    @keyframes spin { to { transform: rotate(360deg); } }
    ngk-icon { animation: spin 1s linear infinite; }
    @media (prefers-reduced-motion: reduce) { ngk-icon { animation: none; } }
  `,
})
export class SignupLoaderComponent {}
